const serverUrl = 'https://xpresscovid-api.ocllis.com/';

export const environment = {
  production: true,
  cryptoPassphrase: '42b9b632-b845-4f0c-8c2f-ab886466da8c',
  frontendUrl: 'https://xpresscovid.ocllis.com/',
  fusionAuth: {
    apiUrl: 'https://authprovider.ocllis.com/api',
    applicationId: '15466867-7a18-43e9-9f4a-5142df5ccc19',
    apiKey: 'kxNYxknru0gUG3suApioUGDrlM0aizctudESfVbvYsg',
    tenantId: '2f477867-975d-42e9-8b27-e5c4c095d6de'
  },
  portalBackend: {
    serverUrl,
    apiUrl: `${serverUrl}api`,
  },
  sentry: {
    dns: 'https://f8a2e380de96444fa6b36c365cf79eec@o430462.ingest.sentry.io/5440506',
  },
};
